module.exports = __webpack_public_path__ + "img/icon_commission@2x.1d7dd7a9.png";